import type { CampanaActualizarInput, CampanaCrearInput, CampanaPublic } from '@app/shared';

import { api } from '../../../lib/api';

// Campañas como datos (Ciclo 1b/1c): la próxima campaña se carga desde acá, sin deploy.
export const campanasApi = {
  async list(): Promise<{ campanas: CampanaPublic[] }> {
    const { data } = await api.get<{ campanas: CampanaPublic[] }>('/campanas');
    return data;
  },

  async create(input: CampanaCrearInput): Promise<{ campana: CampanaPublic }> {
    const { data } = await api.post<{ campana: CampanaPublic }>('/campanas', input);
    return data;
  },

  async update(id: string, input: CampanaActualizarInput): Promise<{ campana: CampanaPublic }> {
    const { data } = await api.patch<{ campana: CampanaPublic }>(`/campanas/${id}`, input);
    return data;
  },
};
